module.exports = __webpack_public_path__ + "static/media/iost.34c0963c.svg";